import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const SCRIPT_ID = "fls-widget-script";

export const HelpButton = () => {
  const { pathname } = useLocation();
  const onWidgetPage = pathname.startsWith("/widget");

  useEffect(() => {
    if (onWidgetPage || document.getElementById("fls-widget-root")) return;
    document.getElementById(SCRIPT_ID)?.remove();
    const s = document.createElement("script");
    s.id = SCRIPT_ID;
    s.src = `${process.env.REACT_APP_BACKEND_URL}/api/widget.js`;
    s.setAttribute("data-title", "FLS Support");
    s.setAttribute("data-position", "right");
    s.setAttribute("data-target", "self");
    document.body.appendChild(s);
  }, [onWidgetPage]);

  return null;
};
